<template>
  <v-img
    class="white--text card-image"
    :aspect-ratio="square ? 1 : 16 / 9"
    :src="image_url"
    :alt="alt"
    :contain="contain"
    :max-height="size"
    :max-width="size"
    :width="width"
    :height="height"
  >
    <slot />
    <template v-slot:placeholder>
      <v-row class="fill-height ma-0" align="center" justify="center">
        <v-progress-circular
          indeterminate
          color="grey lighten-5"
        ></v-progress-circular>
      </v-row>
    </template>
  </v-img>
</template>

<script>
import getImageUrl from "@/services/image.js";

export default {
  name: "CImage",
  props: {
    url: {
      type: String,
      default: null
    },
    square: {
      type: Boolean,
      default: false
    },
    alt: {
      type: String,
      default: "Not found"
    },
    contain: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: "100%"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "100%"
    }
  },
  data: () => ({
    image_url: "",
    imageDownloaded: false
  }),
  methods: {},
  beforeMount() {
    const url = getImageUrl(this.url);
    url
      .getDownloadURL()
      .then(r => {
        this.image_url = r;
        this.imageDownloaded = true;
      })
      .catch(e => {
        console.error("error while downloading image: ", this.url, e);
      });
  }
};
</script>
